import { render } from "./search-filter-resume-bank.vue?vue&type=template&id=619396fa&scoped=true"
import script from "./search-filter-resume-bank.vue?vue&type=script&lang=js"
export * from "./search-filter-resume-bank.vue?vue&type=script&lang=js"

import "./search-filter-resume-bank.vue?vue&type=style&index=0&id=619396fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619396fa"]])

export default __exports__